import { FC } from 'react';

import { useMediaQuery } from 'hooks';
import { useTranslations } from 'context/translations';
import { LandingPageTextKeys } from 'service';
import {
  LandingPageContentKeys,
  LandingPageLinkKeys,
} from 'service/contentful/keys';
import { Button, Showcase } from 'components';
import { CustomLink } from 'components/custom_link/CustomLink';
import Graph from 'components/graph/Graph';

import styles from './HowItWork.module.css';

export const HowItWorkBlock: FC = () => {
  const { t, content, link } = useTranslations();
  const isTabView = useMediaQuery('(max-width: 1240px)');
  return (
    <div className={styles.container}>
      <div className={styles.top_container}>
        <h1>{t(LandingPageTextKeys.HowItWorkBlockTitle)}</h1>
        <div className={styles.description_container}>
          <div>
            <h2>{t(LandingPageTextKeys.HowItWorkBlockCard0Title)}</h2>
            <p>{t(LandingPageTextKeys.HowItWorkBlockCard0Description)}</p>
          </div>
          <div />
          <div>
            <h2>{t(LandingPageTextKeys.HowItWorkBlockCard1Title)}</h2>
            <p>{t(LandingPageTextKeys.HowItWorkBlockCard1Description)}</p>
          </div>
          <div>
            <h2>{t(LandingPageTextKeys.HowItWorkBlockCard2Title)}</h2>
            <p>{t(LandingPageTextKeys.HowItWorkBlockCard2Description)}</p>
          </div>
        </div>
      </div>
      <div className={styles.graph_container}>
        <h2>{t(LandingPageTextKeys.HowItWorkBlockGraphTitle)}</h2>

        <Graph />

        <div className={styles.graph_description}>
          <div>{t(LandingPageTextKeys.HowItWorkBlockGraphColumn0)}</div>
          <div>
            {t(LandingPageTextKeys.HowItWorkBlockGraphColumn1)}{' '}
            <CustomLink
              to={`mailto:${link(LandingPageLinkKeys.HowItWorkBlockMailTo)}`}
              color="primary"
            >
              {t(LandingPageTextKeys.HowItWorkBlockContactUs)}
            </CustomLink>
          </div>
        </div>
      </div>
      <div className={styles.bottom_container}>
        <Showcase
          title={t(LandingPageTextKeys.HowItWorkBlockContentTitle)}
          size={isTabView ? 'small' : 'large'}
          tabs={content(LandingPageContentKeys.HowItWorkBlockContent)}
        >
          <Button
            size="large"
            view="white"
            to={link(LandingPageLinkKeys.AffiliatesLink)}
            className={styles.button}
          >
            {t(LandingPageTextKeys.HowItWorkBlockButton)}
          </Button>
        </Showcase>
      </div>
    </div>
  );
};
